import React from "react";
import "./../RaportyRozhana/NavbarRozhana.css";
import { ProductConsumer } from "../../../Context/AddProWakel";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";

const NavbarRozhana = () => {
  var today = new Date();
  var kat =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  return (
    <ProductConsumer>
      {(value) => {
        const {
          D_rozhanafroshtn,
          D_rozhanaparawagrtn,
          D_jwllakan,
          d_hamw,
          d_froshtn,
          d_parawargrtn,
          D_rozhanaGaranawa,
          d_garanawa,
          getPrint,
          JK_kompanyakan,
          JK_paradan,
          JK_Paradanakan,
          JK_mandubakan,
          d_dataRozhana,
          exportToCSV,
          d_garanawa_Dinar,
          d_garanawa_Dolar
        } = value;

        return (
          <table>
            <tbody
              className="sidebar text-warning  font-weight-bold f4 "
              style={{ backgroundColor: "#2C3539" }}
            >
              <center>
                <h4 className="text-danger pr2">جووڵەی ڕۆژانە</h4>
              </center>
              <td
                style={{
                  backgroundColor: `${d_hamw == true ? "#63120f" : ""}`
                }}
              >
                <span
                  className={`font-weight-bold  pointer`}
                  onClick={D_jwllakan}
                  style={{ paddingLeft: "50px" }}
                >
                  هەموو جووڵەکان
                </span>
              </td>
              <td
                style={{
                  backgroundColor: `${d_froshtn == true ? "#63120f" : ""}`
                }}
              >
                <span
                  className={`font-weight-bold  pointer`}
                  onClick={D_rozhanafroshtn}
                  style={{ paddingLeft: "80px" }}
                >
                  {" "}
                  فرۆشتن
                </span>
              </td>
              <td
                style={{
                  backgroundColor: `${d_parawargrtn == true ? "#63120f" : ""}`
                }}
              >
                <span
                  className={`font-weight-bold  pointer`}
                  onClick={D_rozhanaparawagrtn}
                  style={{ paddingLeft: "65px" }}
                >
                  پارەوەرگرتن
                </span>
              </td>
              <td
                style={{
                  backgroundColor: `${d_garanawa == true ? "#63120f" : ""}`
                }}
              >
                <span
                  className={`font-weight-bold  pointer`}
                  onClick={D_rozhanaGaranawa}
                  style={{ paddingLeft: "50px" }}
                >
                  گەڕانەوە لە وەکیل
                </span>
              </td>

              <td
                style={{
                  backgroundColor: `${JK_paradan == true ? "#63120f" : ""}`
                }}
              >
                <span
                  className={`font-weight-bold  pointer`}
                  onClick={JK_Paradanakan}
                  style={{ paddingLeft: "80px" }}
                >
                  پارەدان
                </span>
              </td>

              <td
                style={{
                  backgroundColor: `${JK_kompanyakan == true ? "#63120f" : ""}`
                }}
              >
                <span
                  className={`font-weight-bold  pointer`}
                  onClick={JK_mandubakan}
                  style={{ paddingLeft: "75px" }}
                >
                  مافی.کۆمپانیا
                </span>
              </td>
              <Link to="/print-raportyRozhana">
                <td>
                  <span
                    className={`font-weight-bold  pointer text-warning`}
                    onClick={getPrint}
                    style={{ paddingLeft: "80px" }}
                  >
                    چاپکردن
                  </span>
                </td>
              </Link>
              <td>
                <span
                  className={`font-weight-bold  pointer text-warning`}
                  style={{ paddingLeft: "80px" }}
                >
                  <button
                    className="btn btn-warning"
                    onClick={(e) => exportToCSV(d_dataRozhana, `${kat}-ڕۆژانە`)}
                  >
                    دابەزاندن
                  </button>
                </span>
              </td>
              <td
                style={{
                  backgroundColor: `${JK_paradan == true ? "#63120f" : ""}`
                }}
              >
                <div className="row">
                  <div className="col-6">
                    <h3 style={{ padding: "5px 30px" }} className="bg-white text-left">
                      <NumberFormat
                        displayType="text"
                        className=" f5 font-weight-bold   border-0 text-left"
                        thousandSeparator={true}
                        value={d_garanawa_Dolar}
                        prefix="$"
                      />
                    </h3>
                  </div>
                  <div className="col-6">
                    <h3 style={{ padding: "5px 30px" }} className="bg-white">
                      <NumberFormat
                        displayType="text"
                        className=" f5 font-weight-bold text-left  border-0"
                        thousandSeparator={true}
                        value={d_garanawa_Dinar}
                        prefix="IQD"
                      />
                    </h3>
                  </div>
                </div>
              </td>
            </tbody>
          </table>
        );
      }}
    </ProductConsumer>
  );
};

export default NavbarRozhana;
